import { useTranslation } from 'react-i18next';

import { Tab } from '@headlessui/react';
import cx from 'classnames';

import ThemedPageHeader from '~/components/PageHeader/ThemedPageHeader';

const ReferralsBreakdown = ({ referrals }: any) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4 flex w-full items-center justify-between space-y-4 pb-8">
      <div className="w-full space-y-4">
        <ThemedPageHeader title={t('referrals.breakdown.title')} description={t('referrals.description')} />
        <Tab.Group>
          <Tab.List className="flex w-full space-x-4 border-b border-gray-200 pb-2">
            <Tab>
              {({ selected }) => (
                <span
                  className={cx(
                    'flex rounded-md px-3 py-2 text-sm font-medium',
                    selected ? 'bg-gray-100 text-gray-700' : 'text-gray-500 hover:text-gray-700',
                  )}
                >
                  {t('referrals.breakdown.confirmed')}{' '}
                  <div className="ml-2 rounded-full bg-gray-300 px-1 text-sm text-gray-900">
                    {referrals.confirmed.length}
                  </div>
                </span>
              )}
            </Tab>
            <Tab>
              {({ selected }) => (
                <span
                  className={cx(
                    'flex rounded-md px-3 py-2 text-sm font-medium',
                    selected ? 'bg-gray-100 text-gray-700' : 'text-gray-500 hover:text-gray-700',
                  )}
                >
                  {t('referrals.breakdown.pending')}
                  <div className="ml-2 rounded-full bg-gray-300 px-1 text-sm text-gray-900">
                    {referrals.pending.length}
                  </div>
                </span>
              )}
            </Tab>
          </Tab.List>
          <Tab.Panels>
            <Tab.Panel>
              {referrals.confirmed.length > 0 ? (
                <div className="mt-4 max-h-80 overflow-auto bg-white shadow sm:rounded-md">
                  <ul className="divide-y divide-gray-200">
                    {referrals.confirmed.map((confirmed: string) => {
                      return (
                        <li key={confirmed}>
                          <div className="px-4 py-4 sm:px-6">
                            <div className="flex items-center justify-between">
                              <p className="truncate text-sm font-medium text-gray-600">{confirmed}</p>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                <p className="mt-4 truncate text-sm font-medium text-gray-600">
                  {t('referrals.breakdown.no_confirmed')}
                </p>
              )}
            </Tab.Panel>
            <Tab.Panel>
              {referrals.pending.length > 0 ? (
                <div className="mt-4 overflow-hidden bg-white shadow sm:rounded-md">
                  <ul className="divide-y divide-gray-200">
                    {referrals.pending.map((pending: string) => {
                      return (
                        <li key={pending}>
                          <span className="block hover:bg-gray-50">
                            <div className="px-4 py-4 sm:px-6">
                              <div className="flex items-center justify-between">
                                <p className="truncate text-sm font-medium text-gray-600">{pending}</p>
                              </div>
                            </div>
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                <p className="mt-4 truncate text-sm font-medium text-gray-600">{t('referrals.breakdown.no_pending')}</p>
              )}
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
};

export default ReferralsBreakdown;
